module.exports = __webpack_public_path__ + "public/img/苍崎科技@1x.9ea7dd00.png";